module.exports = __webpack_public_path__ + "static/media/image2.5464f179.jpg";